import { render, staticRenderFns } from "./CustomField.vue?vue&type=template&id=c251e790&scoped=true"
import script from "./CustomField.vue?vue&type=script&lang=js"
export * from "./CustomField.vue?vue&type=script&lang=js"
import style0 from "./CustomField.vue?vue&type=style&index=0&id=c251e790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c251e790",
  null
  
)

export default component.exports